/**
 * @fileoverview Shared module-header chrome atoms — the app identity mark and
 * the global ⌘J search trigger. Extracted from app-shell.tsx so BOTH the
 * (transitional) shell header and the module-owned `ModuleHeader` compose the
 * same pieces without a circular import (app-shell → header-chrome;
 * components/module/module-header → header-chrome). The theme toggle lives in
 * the account menu (see app-shell `UserMenu`), not the header.
 */

import { InputGroup } from "@blueprintjs/core";
import type { ReactElement } from "react";

import { CmdKHint } from "./command-palette";

/** The IronCase brand mark used in the module header's leading identity cell. */
export function IronCaseBrandIcon(): ReactElement {
  return (
    <svg width={20} height={20} viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
      <path d="M14 2a3 3 0 0 1 3 3v1h2a3 3 0 0 1 3 3v9a3 3 0 0 1 -3 3h-14a3 3 0 0 1 -3 -3v-9a3 3 0 0 1 3 -3h2v-1a3 3 0 0 1 3 -3zm0 2h-4a1 1 0 0 0 -1 1v1h6v-1a1 1 0 0 0 -1 -1" />
    </svg>
  );
}

/** Read-only omnibar trigger that opens the command palette (Quicksearch). */
export function SearchTrigger(): ReactElement {
  return (
    <InputGroup
      data-testid="app-shell-search"
      readOnly
      fill
      leftIcon="search"
      placeholder="Search…"
      rightElement={<CmdKHint />}
      aria-label="Search everything (Cmd+J)"
      // Open via a custom event the CommandPalette listens for. Synthesizing a
      // ⌘J KeyboardEvent does NOT work — Blueprint's useHotkeys ignores
      // synthetic key events.
      onClick={() => window.dispatchEvent(new CustomEvent("iron:open-search"))}
    />
  );
}
